/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  setFormDetails,
  setSubscriptionTiersModalStatus,
} from "../../../../redux/features/shared/sharedSlice";
import { Field, FormikProvider, useFormik } from "formik";
import { Form } from "react-bootstrap";
import FieldInputText from "../common/InputFeilds/InputTextField";
import * as Yup from "yup";
import { REQUIRED } from "../../../../utils/const";
import { useEffect, useState } from "react";
import Select from "react-select";
import { getPartners } from "../../../../redux/features/partner/_partnerAction";
import { getCompanies } from "../../../../redux/features/company/_companyAction";
import {
  addSubscriptionTier,
  updateSubscriptionTier,
} from "../../../../redux/features/subscriptionTiers/_subscriptionTiersAction";

function SubscriptionTiersModal() {
  const dispatch: any = useDispatch();
  const sharedActions: any = useSelector((state: any) => state.sharedActions);
  const [partnerlist, setPartners] = useState<any[]>([]);

  const partners: any =
    useSelector((state: any) => state.partnerList?.data) || [];
  const companies: any =
    useSelector((state: any) => state.companyList?.data) || [];

  const FormValidation = Yup.object().shape({
    name: Yup.string().required(REQUIRED),
    slug: Yup.string().required(REQUIRED),
    priceEgp: Yup.number().min(0, "Must be 0 or more").required(REQUIRED),
    firstTimePrice: Yup.number().min(0, "Must be 0 or more").nullable().transform((value, original) => (original === "" ? null : value)),
    creditsPerCycle: Yup.number().min(1, "Must be at least 1").required(REQUIRED),
    cycleDays: Yup.number().min(1, "Must be at least 1").required(REQUIRED),
    partners: Yup.array()
      .min(1, "At least one partner is required")
      .required(REQUIRED),
    description: Yup.string(),
  });

  const companyList = companies?.map((item: any) => ({
    value: item._id,
    label: item.companyName,
  }));

  const options = partners?.map((item: any) => ({
    value: item._id,
    label: item.businessName,
    _id: item._id,
  }));

  const formInitialValues = {
    name: sharedActions?.formDetails?.name || "",
    slug: sharedActions?.formDetails?.slug || "",
    priceEgp: sharedActions?.formDetails?.priceEgp || 0,
    firstTimePrice: sharedActions?.formDetails?.firstTimePrice ?? "",
    creditsPerCycle: sharedActions?.formDetails?.creditsPerCycle || 0,
    cycleDays: sharedActions?.formDetails?.cycleDays || 30,
    companyId: sharedActions?.formDetails?.companyId?._id || sharedActions?.formDetails?.companyId || "",
    partners: sharedActions?.formDetails?.partners || [],
    description: sharedActions?.formDetails?.description || "",
    features: sharedActions?.formDetails?.features?.join(", ") || "",
    sortOrder: sharedActions?.formDetails?.sortOrder || 0,
    isActive: sharedActions?.formDetails?.isActive !== undefined ? sharedActions?.formDetails?.isActive : true,
  };

  useEffect(() => {
    dispatch(getPartners({ page: 1, limit: 100 }));
    dispatch(getCompanies({ page: 1, limit: 100 }));
  }, []);

  useEffect(() => {
    if (sharedActions?.formDetails?.partners) {
      let preselectedPartners = sharedActions.formDetails.partners
        .map((partnerId) =>
          options.find((option) => option.value === (partnerId._id || partnerId))
        )
        .filter(Boolean);
      setPartners(preselectedPartners);
      tierFormik.setFieldValue("partners", sharedActions.formDetails.partners);
    }
  }, [sharedActions, partners]);

  const tierFormik: any = useFormik({
    initialValues: formInitialValues,
    validationSchema: FormValidation,
    onSubmit: (values: any, { resetForm }) => {
      const submitValues = {
        ...values,
        partners: values.partners.map((p: any) => p._id || p.value || p),
        features: values.features ? values.features.split(",").map((f: string) => f.trim()).filter(Boolean) : [],
        companyId: values.companyId || null,
        firstTimePrice: values.firstTimePrice === "" ? null : Number(values.firstTimePrice),
      };
      if (sharedActions?.formDetails?._id) {
        dispatch(
          updateSubscriptionTier({
            ...submitValues,
            id: sharedActions.formDetails?._id,
          })
        );
      } else {
        dispatch(addSubscriptionTier({ ...submitValues }));
      }
      dispatch(setFormDetails({}));
      setTimeout(() => {
        dispatch(setSubscriptionTiersModalStatus(false));
        resetForm();
      }, 500);
    },
    enableReinitialize: true,
  });

  const closeModal = () => {
    dispatch(setSubscriptionTiersModalStatus(false));
    dispatch(setFormDetails({}));
  };

  const handleSelectChange = (selectedOptions: any) => {
    const selectedValues = partners
      .map((partner: any) => {
        const matchedPartner = selectedOptions.find(
          (option: any) => option.value === partner._id
        );
        return matchedPartner || null;
      })
      .filter(Boolean);
    tierFormik.setFieldValue("partners", selectedValues);
    setPartners(selectedValues);
  };

  return (
    <>
      <Modal
        backdrop="static"
        size="lg"
        show={sharedActions.subscriptionTiersModal}
        onHide={closeModal}
        animation={true}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {!sharedActions.formDetails?._id ? "Add" : "Update"} Subscription Tier
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormikProvider value={tierFormik}>
            <Form onSubmit={tierFormik.handleSubmit} method="POST">
              <div className="row">
                <div className="col-sm-6 col-md-6 mb-6">
                  <Form.Group>
                    <Field
                      name="name"
                      validate={FormValidation}
                      type="text"
                      label="Name"
                      isRequired={true}
                      component={FieldInputText}
                      placeholder="e.g. Starter, Core, Pro"
                      maxLength={50}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-6 mb-6">
                  <Form.Group>
                    <Field
                      name="slug"
                      validate={FormValidation}
                      type="text"
                      label="Slug"
                      isRequired={true}
                      component={FieldInputText}
                      placeholder="e.g. starter, core, pro"
                      maxLength={50}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="priceEgp"
                      validate={FormValidation}
                      type="number"
                      min={0}
                      isRequired={true}
                      label="Price (EGP)"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="firstTimePrice"
                      validate={FormValidation}
                      type="number"
                      min={0}
                      label="First-Time Price (EGP)"
                      component={FieldInputText}
                      placeholder="Leave empty for no discount"
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="creditsPerCycle"
                      validate={FormValidation}
                      type="number"
                      min={1}
                      isRequired={true}
                      label="Credits Per Cycle"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="cycleDays"
                      validate={FormValidation}
                      type="number"
                      min={1}
                      isRequired={true}
                      label="Cycle Days"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-6 mb-6">
                  <Form.Label>Company (optional)</Form.Label>
                  <Select
                    className="custom-select-box"
                    value={companyList.find(
                      (g) => g.value === tierFormik.values?.companyId
                    ) || null}
                    name="companyId"
                    placeholder="Select Company (or leave empty)"
                    isClearable
                    onChange={(v) => {
                      tierFormik.setFieldValue("companyId", v?.value || "");
                    }}
                    options={companyList}
                  />
                </div>
                <div className="col-sm-6 col-md-6 mb-6">
                  <Form.Label>
                    Partners <span>*</span>
                  </Form.Label>
                  <Select
                    isMulti
                    options={options}
                    value={options.filter((option) =>
                      tierFormik.values.partners.some(
                        (partner) => (partner._id || partner.value || partner) === option._id
                      )
                    )}
                    onChange={handleSelectChange}
                    placeholder="Select partners"
                    className={`react-select-container ${
                      tierFormik.errors.partners &&
                      tierFormik.touched.partners
                        ? "is-invalid"
                        : ""
                    }`}
                    classNamePrefix="react-select"
                  />
                  {tierFormik.errors.partners &&
                    tierFormik.touched.partners && (
                      <div className="invalid-feedback">
                        {tierFormik.errors.partners}
                      </div>
                    )}
                </div>
                <div className="col-sm-12 col-md-12 mb-6">
                  <Form.Group>
                    <Field
                      name="description"
                      validate={FormValidation}
                      type="text"
                      label="Description"
                      component={FieldInputText}
                      maxLength={500}
                      placeholder="Tier description"
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-12 col-md-12 mb-6">
                  <Form.Group>
                    <Field
                      name="features"
                      validate={FormValidation}
                      type="text"
                      label="Features (comma-separated)"
                      component={FieldInputText}
                      maxLength={500}
                      placeholder="e.g. Priority booking, All studios, Carry-over credits"
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6">
                  <Form.Group>
                    <Field
                      name="sortOrder"
                      validate={FormValidation}
                      type="number"
                      min={0}
                      label="Sort Order"
                      component={FieldInputText}
                    />
                  </Form.Group>
                </div>
                <div className="col-sm-6 col-md-4 mb-6 d-flex align-items-end">
                  <Form.Check
                    type="switch"
                    id="isActive"
                    label="Active"
                    checked={tierFormik.values.isActive}
                    onChange={(e) =>
                      tierFormik.setFieldValue("isActive", e.target.checked)
                    }
                  />
                </div>
              </div>

              <Modal.Footer>
                <Button
                  type="button"
                  variant="secondary"
                  className="primaryBtn"
                  onClick={closeModal}
                >
                  Cancel
                </Button>
                <Button type="submit" className="primaryBtn active">
                  Submit
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Modal.Body>
      </Modal>
    </>
  );
}

export { SubscriptionTiersModal };
